var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheckboxSelected(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    className: "checkbox_selected_svg__box",
    stroke: "#AB7DCC",
    fill: "#AB7DCC",
    d: "M1.5 1.5h21v21h-21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "checkbox_selected_svg__tick",
    d: "M16.115 9.369l-5.207 5.415a.715.715 0 01-1.044 0L7.267 12.06a.792.792 0 010-1.09.715.715 0 011.044 0l2.087 2.18 4.685-4.87a.715.715 0 011.044 0 .803.803 0 01-.012 1.09z",
    fill: "#FFF"
  }))));
}

export default SvgCheckboxSelected;